import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { TextStyle } from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import { FontSize } from './extensions/FontSize';
import { Color } from './extensions/Color';
import { FontFamily } from './extensions/FontFamily';
import { Highlight } from './extensions/Highlight';
import { CustomParagraph } from './extensions/Paragraph';
import { CustomTableCell } from './extensions/TableCell';
import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableHeader } from '@tiptap/extension-table-header';
import './styles.scss';
import { Toolbar } from './Toolbar';
const TipTapEditor = ({ value, placeholder = 'Enter text here...', onChange, disabled = false }) => {
    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                heading: {
                    levels: [1, 2, 3]
                },
                paragraph: false
            }),
            CustomParagraph,
            TextStyle,
            Color.configure({
                types: ['textStyle']
            }),
            FontFamily.configure({
                types: ['textStyle']
            }),
            FontSize.configure({
                types: ['textStyle']
            }),
            Highlight.configure({
                multicolor: true
            }),
            Underline,
            Link.configure({
                openOnClick: false
            }),
            Table.configure({
                resizable: true
            }),
            TableRow,
            TableHeader,
            CustomTableCell
        ],
        content: value,
        editable: !disabled,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        }
    });
    useEffect(() => {
        if (editor && value !== editor.getHTML()) {
            editor.commands.setContent(value);
        }
    }, [value, editor]);
    if (!editor) {
        return null;
    }
    return (_jsxs("div", { className: 'tiptap-editor-wrapper', children: [_jsx(Toolbar, { editor: editor }), _jsx("div", { className: 'tiptap-editor-content', children: _jsx(EditorContent, { editor: editor }) })] }));
};
export default TipTapEditor;
